





























































































































































































































import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { InvoiceRoutingInvoiceModel } from "./models";
import {
  FinancialDocumentTypesEnum,
  PaymentMeansEnum,
} from "@/shared/models/enums.type";
import { PaymentMean } from "@/shared/models/paymentMean";
import { CardType } from "@/shared/models/cardType";
import VCustomer from "@/shared/models/vCustomer";
import CustomerLookup from "@/components/misc/CustomerLookup.vue";
import { TaxRateView } from "@/shared/models/taxRates";
import { UnitOfMeasureView } from "@/shared/models/unitOfMeasure";
import * as _ from "lodash";

@Component({
  components: {
    CustomerLookup,
  },
})
export default class InvoiceRoutingInvoice extends Vue {
  @PropSync("invoice") internalInvoice!: InvoiceRoutingInvoiceModel;
  @Prop() index!: number;
  @Prop() originDocumentTypeId!: FinancialDocumentTypesEnum;

  financialDocumentTypesEnum = FinancialDocumentTypesEnum;

  get titleId() {
    return this.index + 1;
  }

  get titleItems() {
    const items = [
      {
        text: this.$t("Invoice") + " #" + this.titleId,
        value: FinancialDocumentTypesEnum.Racun,
      },
    ];

    if (this.tenantGeneratesDeliveryNotes) {
      items.push({
        text: this.$t("DeliveryNote") + " #" + this.titleId,
        value: FinancialDocumentTypesEnum.Otpremnica,
      });
    }

    return items;
  }

  get date() {
    return new Date();
  }

  get showCardTypeSelection() {
    const paymentMeansId = this.internalInvoice.paymentMeansId ?? 0;

    if (
      paymentMeansId === PaymentMeansEnum.KreditnaKartica ||
      paymentMeansId === PaymentMeansEnum.BankovnaKartica ||
      this.paymentMeanBaseId === PaymentMeansEnum.KreditnaKartica ||
      this.paymentMeanBaseId === PaymentMeansEnum.BankovnaKartica
    ) {
      return true;
    } else {
      this.internalInvoice.cardTypeId = null;
      return false;
    }
  }

  get paymentMeanBaseId() {
    return this.paymentMeans?.find(
      (e) => e.id === this.internalInvoice.paymentMeansId
    )?.paymentMeanBaseId;
  }

  customerLookupOpen = false;
  unselect() {
    if (this.internalInvoice.customerId) {
      this.internalInvoice.customerId = null;
      this.internalInvoice.customerName = "";
      this.internalInvoice.customerOib = "";
    }
  }

  get filterPrefil() {
    return {
      name: this.internalInvoice.customerName ?? "",
      identificationNumber: this.internalInvoice.customerOib ?? "",
    };
  }

  get lookupHeaders() {
    return [
      {
        text: "VFinancialDocument.Customer.name",
        value: "name",
      },
      {
        text: "VFinancialDocument.Customer.oib",
        value: "identificationNumber",
      },
    ];
  }

  selected(customer: VCustomer) {
    this.internalInvoice.customerId = customer.id;
    this.internalInvoice.customerName = customer.name;
    this.internalInvoice.customerOib = customer.isLegalEntity
      ? customer.identificationNumber
      : "";
  }

  openCustomerLookup() {
    this.customerLookupOpen = true;
  }

  getUnitOfMeasureName(id: number) {
    const unit = this.unitsOfMeasure?.find((e) => e.id === id);
    if (unit) return this.$t(unit.textResourceKey).toString();
    return "";
  }

  getTaxRateName(id: number) {
    const taxRate = this.taxRates?.find((e) => e.id === id);
    if (taxRate) return taxRate.name;
    return "";
  }

  get rules() {
    return {
      required: (value: any) =>
        !!value || this.$t("Validation.Required").toString(),
      customerMustBeSelected: () =>
        !!this.internalInvoice.customerId ||
        this.$t("Customer must be selected"),
    };
  }

  get errors() {
    const groupedByPropertyId = _.map(
      _.groupBy(this.internalInvoice.items, (x) => x.propertyId),
      (x) => x
    ).length;
    const groupedByOwnerId = _.map(
      _.groupBy(this.internalInvoice.items, (x) => x.ownerId),
      (x) => x
    ).length;
    const groupedByWorkModel = _.map(
      _.groupBy(this.internalInvoice.items, (x) => x.agencyWorkModelId),
      (x) => x
    ).length;
    const groupedByVatCategoryForPrepayments = _.map(
      _.groupBy(
        this.internalInvoice.items,
        (x) => x.vatCategoryForPrepaymentsId
      ),
      (x) => x
    ).length;

    const errors = [
      groupedByPropertyId <= 1
        ? ""
        : this.$t(
            "Same invoice cannot contain items from different properties"
          ).toString(),
      // all for same owner, or routing is not done by owners and they have the same work model and prepayment VAT category
      // while the invoice is not a delivery note, or cancellation
      groupedByOwnerId <= 1 ||
      (this.internalInvoice.documentTypeId ===
        FinancialDocumentTypesEnum.Racun &&
        !this.internalInvoice.items.some((x) => x.isStayCancellation) &&
        !this.routeInvoicesForOwnNameAndOtherInvoice &&
        groupedByWorkModel <= 1 &&
        groupedByVatCategoryForPrepayments <= 1)
        ? ""
        : this.$t(
            "Same invoice cannot contain items from different owners"
          ).toString(),
      groupedByWorkModel <= 1
        ? ""
        : this.$t(
            "Same invoice cannot contain items with different agency work models"
          ).toString(),
    ];

    this.internalInvoice.errors = errors.filter((x) => !!x);
    return this.internalInvoice.errors;
  }

  // drag&drop
  entered = false;
  dragEnter(e: DragEvent) {
    if (this.entered) return;

    const check = e.dataTransfer?.types.includes("application/json+lineitem");
    if (!check) return;

    this.entered = true;

    e.preventDefault();
    this.$emit("dragIn");
    (e.currentTarget as HTMLTableElement).classList.add("drag");
  }
  dragOver(e: DragEvent) {
    const check = e.dataTransfer?.types.includes("application/json+lineitem");
    if (!check) {
      return;
    }

    e.preventDefault();
  }
  dragLeave(e: DragEvent) {
    if (!this.entered || e.currentTarget != e.target) return;

    this.entered = false;

    this.$emit("dragOut");
    (e.currentTarget as HTMLTableElement).classList.remove("drag");
  }
  dropped(e: DragEvent) {
    this.entered = false;
    this.$emit("dropped");
    (e.currentTarget as HTMLTableElement).classList.remove("drag");
  }

  @Getter("appParams/tenantGeneratesDeliveryNotes")
  tenantGeneratesDeliveryNotes?: boolean;

  @Getter("codebooks/paymentMeans") paymentMeans?: PaymentMean[];
  @Getter("codebooks/cardTypes") cardTypes?: CardType[];

  @Getter("appParams/isCardTypeRequiredForCardPaymentMeans")
  isCardTypeRequiredForCardPaymentMeans?: boolean;

  @Getter("codebooks/taxRates") taxRates?: TaxRateView[];
  @Getter("codebooks/unitsOfMeasure") unitsOfMeasure?: UnitOfMeasureView[];

  @Getter("appParams/routeInvoicesForOwnNameAndOtherInvoice")
  routeInvoicesForOwnNameAndOtherInvoice?: boolean;

  @Getter("appParams/tenantPaysVat") tenantPaysVat?: boolean;
  get paysVat() {
    return this.tenantPaysVat ?? false;
  }
}
